module.exports = __webpack_public_path__ + "static/media/graphics.cd823653.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/graphics.png
// module id = 351
// module chunks = 0